export default class Subscription {
  public id: string
  public startDate: string
  public endDate: string
  public entityId: string
  public remark: string
  public createdOn: string
  public updatedOn: string
  public activatedOn: string
  public updateByUserId: string
  public assetOwner: string
  public state: any
  public environment: any
  public roles: any[]
  public product: any
  public subscriptionProvider: string
}


// WEBPACK FOOTER //
// ./src/modules/consumer/models/Subscription.ts